import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',fontFamily:'Sora,sans-serif',color:'#9094a8'}}>Loading…</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect to the correct home for this role
    const home =
      user.role === 'super-admin'  ? '/super/schools' :
      user.role === 'teacher'      ? '/teacher/dashboard' :
      user.role === 'student'      ? '/student/dashboard' :
      user.role === 'coordinator'  ? '/coordinator/dashboard' :
      user.role === 'finance'      ? '/finance/dashboard' :
      user.role === 'parent'       ? '/parent/dashboard' :
      user.role === 'owner'        ? '/owner/dashboard' :
      user.role === 'librarian'      ? '/librarian/dashboard' :
      user.role === 'hostel_member'  ? '/hostel/dashboard' :
      '/dashboard';
    return <Navigate to={home} replace />;
  }

  return children;
};

export default PrivateRoute;